// ==============================
// Imports
// ==============================

// MUI Components
import AppBarSpacer from '../components/common/AppBarSpacer';
import PageHeader from '../components/common/PageHeader';

// Libraries
import { useState } from 'react';

// Local components
import MiniDrawer from '../components/MiniDrawer';
import AssessmentTable from '../components/AssessmentTable';
import { useTranslation } from '../i18n';

const AssessmentLayout = () => {
  const { t } = useTranslation();

  // States
  const [open, setOpen] = useState(true);

  // ==============================
  // Render
  // ==============================
  return (
    <>
      <div className="flex h-screen">
        {/* Sidebar */}
        <MiniDrawer open={open} setOpen={setOpen} />

        {/* Main content */}
        <main className="flex-1 overflow-auto app-page-bg">
          {/* Offset for fixed AppBar (height = 64px) */}
          <AppBarSpacer />

          <div className="h-full px-6 py-4">
            <PageHeader
              title={t('assessment.title')}
              subtitle={t('assessment.subtitle')}
            />
            {/* Registration table */}
            <AssessmentTable />
          </div>
        </main>
      </div>
    </>
  );
};

export default AssessmentLayout;
